import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import CustomDropDown from "../Common/customDropDown";
import { formInputErrorMsg } from "./empConstants";
import { FOLDERPATH, FOLDERPATHROUTER } from "../../Constants/config";

function EMPAutoCompleteSelect({
  type,
  options,
  verificationType,
  name,
  id,
  label,
  fieldId,
  isRequired,
  errId,
  caseCheckId,
  returnType,
  value,
  hiddenValue,
  selectedLabel,
  checkDetailsIndex,
  fieldName,
  handleTextChange,
  fieldValue,
  hasError = null,
}) {
  const [selectedOptionId, setSelectedOptionId] = useState();
  const [showFilterDiv, setShowFilterDiv] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [runRequest, setRunRequest] = useState(false);
  const [autoSuggestOptionData, setAutoSuggestOption] = useState([]);
  const [currentSelectedVal, setCurrentSelectedVal] = useState(null);
  const [selectedValue, setSelectedValue] = useState("");
  const [autoSuggestLoading, setAutoSuggestLoading] = useState(false);
  const inputText = useRef();

  useEffect(()=> {

    if(!fieldValue) {
      inputText.current.value= ""
    } else  {
      inputText.current.value = fieldValue
    }
  },[fieldValue])

  useEffect(() => {
    let apiData;

    const fetchCompany = async (value) => {
      setShowFilterDiv(true);
      setAutoSuggestLoading(true);
      const requestData = {
        term: value,
        verification_type: verificationType,
      };
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
      apiData = await axios.post( FOLDERPATH +
        "/GenericApi/getVerificationData",
        requestData,
        {
          headers,
        }
      );

      let optionsFormat = [];

      if (apiData.data.length === 0) {
        optionsFormat.push({ value: "other", name: "other" });
      } else {
        optionsFormat = [...apiData.data];
        optionsFormat.push({ value: "other", name: "other" });
      }

      setAutoSuggestOption(optionsFormat);
      setAutoSuggestLoading(false);
    };

    const fetchReason = async (value) => {
      setShowFilterDiv(true);
      setAutoSuggestLoading(true);
      const requestData = {
        search: value,
        
      };
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
      apiData = await axios.post(FOLDERPATH +
        "/GenericApi/getReasonForLeaving",
        requestData,
        {
          headers,
        }
      );

      let optionsFormat = [];

      if (apiData.data.data.length === 0) {
        optionsFormat.push({ value: "other", name: "other" });
      } else {
        optionsFormat = [...apiData.data.data];
        optionsFormat.push({ value: "other", name: "other" });
      }

      setAutoSuggestOption(optionsFormat);
      setAutoSuggestLoading(false);
    };

    const fetchDesignation = async (value) => {
      setShowFilterDiv(true);
      setAutoSuggestLoading(true);
      const requestData = {
        search: value,
        
      };
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
      apiData = await axios.post( FOLDERPATH +
        "/GenericApi/getDesignation",
        requestData,
        {
          headers,
        }
      );

      let optionsFormat = [];

      if (apiData.data.data.length === 0) {
        optionsFormat.push({ value: "other", name: "other" });
      } else {
        optionsFormat = [...apiData.data.data];
        optionsFormat.push({ value: "other", name: "other" });
      }

      setAutoSuggestOption(optionsFormat);
      setAutoSuggestLoading(false);
    };

    if (typeof keyword == "string" && keyword.length === 0) {
      setShowFilterDiv(false);
      setAutoSuggestOption([]);
    } else {
      if (selectedOptionId === null) {
        if(fieldName == 'reason_for_leaving'){
          fetchReason(keyword);
        }else if(fieldName == 'company_designation'){
          fetchDesignation(keyword);
        }else{
          fetchCompany(keyword);
        }
      } else {
        setShowFilterDiv(false);
      }
    }
  }, [runRequest, keyword]);

  const debounceFunction = (func, delay) => {
    let timer;
    return function (...args) {
      const context = this;
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  };

  const inputTypeHandler = (e) => {
    setKeyword(e.target.value);
    setSelectedValue(e.target.value);
    setSelectedOptionId(null);
    setRunRequest(true);
    if(e?.target?.value === "") {
      handleChange({name : "", value: ""});
    }
  };
  const optimisedSearch = debounceFunction(inputTypeHandler, 500);

  const handleChange = (selectedOption) => {
    setCurrentSelectedVal(selectedOption.name);
    setShowFilterDiv(false);
    inputText.current.value = selectedOption.name;
    const textValues = {
      dataset: {
        fieldname: fieldName,
        checkdetailsindex: checkDetailsIndex,
      },
      value: selectedOption.name,
    };
    handleTextChange(textValues, selectedOption);
  };

  const errorMsg =
    (fieldValue == null || fieldValue == "") && isRequired == 1
      ? formInputErrorMsg.requiredError
      : formInputErrorMsg.InvalidError;

  return (
    <div className="col-sm-4 col-md-12 col-xl-4">
      <div className="form-group">
        <div className="floating-label">
          <input
            type="text"
            className="form-control"
            name={name}
            id={fieldName}
            onChange={optimisedSearch}
            autoComplete="off"
            ref={inputText}
            defaultValue={fieldValue}
          />
          <label
            htmlFor={fieldName}
            className={(fieldValue || keyword) && "focused"}
          >
            {label}
            {isRequired && <sup className="text-danger">*</sup>}
          </label>
          {autoSuggestLoading && (
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
              style={{
                position: "absolute",
                top: "15px",
                right: "12px",
              }}
            ></span>
          )}
        </div>
        {showFilterDiv && (
          <CustomDropDown
            optionData={autoSuggestOptionData}
            selectOption={handleChange}
            classes="suggestion-list"
            autoSuggestLoading={autoSuggestLoading}
          />
        )}

        {hasError && hasError === true && (
          <p className="err text-danger" id={errId}>
            {errorMsg}
          </p>
        )}
      </div>
    </div>
  );
}

export default EMPAutoCompleteSelect;
